import axios from 'axios'
import { alert, Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'

// create an axios instance
// axios.defaults.withCredentials=true
const service = axios.create({
  // baseURL: 'https://shixun.serve.caihongpi.net',
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://192.168.1.103',
  // baseURL: 'https://test2.service.eswonline.com',
  // baseURL: 'http://127.0.0.1:7005',
  // baseURL: 'http://120.79.166.138:7005',
  timeout: 60000, // 将请求超时时长从30000修改为60000（60秒）
  // withCredentials: true,
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
      // config.headers['Access-Control-Allow-Origin'] = 'true'
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = getToken()
  }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */
  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  // 6c4a173afbeb79586b5536b31222be94
  response => {
    const res = response.data
    if (res.errCode) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    const code = error.request.status
    // console.log(error.StatusCode) // for debug
    if (code === 401) {
      // Message({
      //   message: '登录信息失效请重新登陆',
      //   type: 'error',
      //   duration: 5 * 1000
      // }) 
      removeToken()
      alert('登录信息失效请重新登陆')
      window.location.href = '/#'
      // alert('登录信息失效请重新登陆', '警告', {
      //   confirmButtonText: '确定',
      //   callback: action => {
      //     window.location.href = '/#'
      //   }
      // });
      // store.dispatch('user/resetToken').then(() => {
      //           location.reload()
      //         })
    } else {
      Message({
        message: error.message || '服务器错误，请稍后再试',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js